import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import { triggerBase64Download } from 'common-base64-downloader-react';
import {
  Container,
  Card,
  Form,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Col,
  Row
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faBoltLightning,
  faClose,
  faCheck,
  faHourglass,
  faReply
} from "@fortawesome/free-solid-svg-icons";
import { 
  updateCurrentPage, 
  downloadReviewMedicalClaims,
  updateSearch,
  searchReviewClaimsPagination,
  searchReviewClaimsPageCount,
  downloadMedicalClaimsAttachments,
  searchReviewClaimsArray,
  resetID
} from "../../3.Store/ReviewMedicalClaimsSlice";
import { ThreeDots } from 'react-loader-spinner';
import './styles.css';
import Swal from 'sweetalert2';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "../../2.Commons/Pagination";

const HRReviewMedicalList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const medicalClaims = useSelector(state => state.ReviewMedicalClaimsSlice.lists) || [];
  const currentPage = useSelector(state => state.ReviewMedicalClaimsSlice.currentPage);
  const totalPages = useSelector(state => state.ReviewMedicalClaimsSlice.totalPages);
  const search = useSelector((state) => state.ReviewMedicalClaimsSlice.search);
  const ids = useSelector((state) => state.ReviewMedicalClaimsSlice.ids);
  const { searchText, fromDate, toDate } = search;
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [isSelectAllActive, setIsSelectAllActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const role = JSON.parse(localStorage.getItem("roles"));

  useEffect(() => {
    if (!role || !role.includes("HR-M-BENEFIT")) {
      localStorage.clear();
      window.location.href = "/Login"; 
    }
    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get('currentPage') || 1;
    const searchText = queryParams.get('searchText') || '';
    const fromDate = queryParams.get('fromDate') || '';
    const toDate = queryParams.get('toDate') || '';
    dispatch(updateCurrentPage(parseInt(page)));
    setLoading(true);
    if (searchText) {
      const entity = { ...search, 
        searchText: searchText,
        fromDate: fromDate,
        toDate: setToDateToOneDayAhead(toDate)
      };
      //dispatch(updateSearch(entity));
      // If there is searchText, dispatch searchReviewClaimsPagination
      dispatch(searchReviewClaimsPagination({ currentPage: parseInt(page), entity: { ...entity } }))
        .then(() => {
          dispatch(searchReviewClaimsPageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      const entity = { ...search, 
        searchText: "",
        fromDate: search.fromDate,
        toDate: setToDateToOneDayAhead(search.toDate)
      };
      // If there is no searchText, fetch the regular pagination data
      dispatch(searchReviewClaimsPagination({ currentPage: parseInt(page), entity: { ...entity } }))
        .then(() => {
          dispatch(searchReviewClaimsPageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [location.search]); // Only location.search is a dependency

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (ids?.length) {
      setSelectedCheckboxes(ids);
      console.log("Updated IDs:", ids);
    }
  }, [ids]);

  const handleDateChange = (e) => {
    const entity = { ...search, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateSearch(entity));
  };

  const handleSearch = (e) => {
    const entity = {...search, searchText: e.target.value}
    dispatch(updateSearch(entity));
  }

  const setToDateToOneDayAhead = (toDate) => {
    // Create a Date object from the input toDate string
    const date = new Date(toDate);
    
    // Add one day to the date
    date.setDate(date.getDate() + 1);
    
    // Format the date back to YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  };
  
  const handleBtnSearch = () => {
    setIsSelectAllActive(false);
    setSelectedCheckboxes([]);
    const entity = { ...search, toDate: setToDateToOneDayAhead(search.toDate) };
    setLoading(true);
    dispatch(updateCurrentPage(1));
      dispatch(searchReviewClaimsPagination({ currentPage: 1, entity }))// Pass searchText as part of entity
      .then(() => {
        dispatch(searchReviewClaimsPageCount(entity));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBtnSearch();
    }
  };

  const handleBtnDownload = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Download report from " + fromDate + " to " + toDate,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        // const entity = { ...search, toDate: setToDateToOneDayAhead(search.toDate) };
        const entity = { ...search };
        const report = dispatch(downloadReviewMedicalClaims({ ...entity }));
        report.then((data) => {
            try {
              // Ensure the payload is a string
              console.log(data.payload);
              
              if (typeof data.payload !== 'string') {
                  throw new Error('Invalid payload format');
              }
              // Decode the base64-encoded data
              const base64EXCEL = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data.payload}`;
              // Get current date and time
              const now = new Date();
              const day = String(now.getDate()).padStart(2, '0');
              const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
              const year = now.getFullYear();
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
              const seconds = String(now.getSeconds()).padStart(2, '0');
              
              // Create filename with date and time
              const filename = `Medical_Claims_${day}-${month}-${year}--${hours}-${minutes}-${seconds}`;
              
              // Trigger download
              triggerBase64Download(base64EXCEL, filename);
            } catch (error) {
              console.error('Error handling download:', error);
            } finally {
              setLoading(false); // Set loading to false after data fetching completes
            }
        }).catch((error) => {
          console.error('Error fetching report data:', error);
          setLoading(false); // Set loading to false if an error occurs
        });
      }
    });
  };

  const handleBtnDownloadAttachment = () => {
    setLoading(true);
    // const entity = { ...search, toDate: setToDateToOneDayAhead(search.toDate) };
    const entity = { ids: selectedCheckboxes };
    const report = dispatch(downloadMedicalClaimsAttachments({ ...entity }));
    report.then((data) => {
        try {
          if (typeof data.payload !== 'string') {
              throw new Error('Invalid payload format');
          }
          // Decode the base64-encoded data
          const base64PDF = `data:application/pdf;base64,${data.payload}`;
          // Get current date and time
          const now = new Date();
          const day = String(now.getDate()).padStart(2, '0');
          const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const year = now.getFullYear();
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          
          // Create filename with date and time
          const filename = `Medical_Claims_Attachments_${day}-${month}-${year}--${hours}-${minutes}-${seconds}`;
          
          // Trigger download
          triggerBase64Download(base64PDF, filename);
        } catch (error) {
          console.error('Error handling download:', error);
        } finally {
          setLoading(false); // Set loading to false after data fetching completes
        }
    }).catch((error) => {
      console.error('Error fetching report data:', error);
      setLoading(false); // Set loading to false if an error occurs
    });
  };

  const handleBtnBack = () => {
    setSelectedCheckboxes([]);
    navigate("/");
  };

  const handleClickView = (medicalId) => {
    navigate(`/HRReviewMedicalForm/${medicalId}?currentPage=${currentPage}&searchText=${searchText}&fromDate=${fromDate}&toDate=${toDate}`);
  };  

  const handleCheckChange = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedCheckboxes(prevState => [...prevState, id]);
    } else {
      setSelectedCheckboxes(prevState => prevState.filter(item => item !== id));
    }
  };

  const handlePreviousPage = () => {
    setLoading(true);
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      const entity = { ...search, toDate: setToDateToOneDayAhead(search.toDate) };
        dispatch(searchReviewClaimsPagination({ currentPage: currentPage - 1, entity }))
        .then(() => {
          dispatch(searchReviewClaimsPageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleNextPage = () => {
    setLoading(true);
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      const entity = { ...search, toDate: setToDateToOneDayAhead(search.toDate) };
        dispatch(searchReviewClaimsPagination({ currentPage: currentPage + 1, entity }))
        .then(() => {
          dispatch(searchReviewClaimsPageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    dispatch(updateCurrentPage(page));
    const entity = { ...search };
      dispatch(searchReviewClaimsPagination({ currentPage: page, entity }))
      .then(() => {
        dispatch(searchReviewClaimsPageCount(entity));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };  

  const handleSelectAll = () => {

    if (isSelectAllActive) {
      // Second click - unselect/reset or take alternate action
      console.log("Second click - clearing or toggling off");
      // Optional: dispatch a clear action or reset selection
      dispatch(resetID());
      setIsSelectAllActive(false);
      setSelectedCheckboxes([]);
      return;
    }

    setLoading(true);
    const entity = { ...search, toDate: setToDateToOneDayAhead(search.toDate) };
    dispatch(searchReviewClaimsArray({ ...entity }))
    .then(() => {
      setLoading(false);
      setIsSelectAllActive(true);
    })
    .catch(() => {
      setLoading(false);
    });
  };  

  const renderStaffList = () => {
    return medicalClaims.map(claim => {
      // const rowStyle = claim?.employee?.service_length?.id === "P" ? { backgroundColor: 'pink !important' } : {};
      const rowStyle = claim.employee.status.id === 2 ? { backgroundColor: '#ff7047' } : claim.employee.service_length.id === "P" ? { backgroundColor: 'lightblue' } : '';

      return (
      <tr key={claim.id} 
        style={{ 
          cursor: 'pointer'        
          // ...rowStyle 
        }}
      >
        {isMobile ? (
          <>
            <td style={{...rowStyle}} onClick={()=>handleClickView(claim.id)}>
              <strong>{claim.employee.fullname}</strong>
              <br/>
              <strong>Amount: RM{claim.amount}</strong>
              <br/>
              <strong>Date: {moment(claim.created).format("YYYY-MM-DD")}</strong>
              <br/>
              <strong>Practitioner: </strong>{claim.receipt_reference}
              <br/>
              <strong>Receipt No: </strong>{claim.receipt_no}
            </td>
            <td className="text-center align-middle" style={{...rowStyle}}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{claim.status.description}</Tooltip>}
              >
                <span>
                  {claim.status.description == "APPROVED-HR" && (
                    <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                  )}
                  {claim.status.description == "APPROVED-S" && (
                    <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                  )}
                  {claim.status.description == "PENDING" && (
                    <FontAwesomeIcon icon={faHourglass} style={{color: "#FFD43B",}} />
                  )}
                  {claim.status.description == "WITHDRAWN" && (
                    <FontAwesomeIcon icon={faReply} style={{color: "#FFD43B",}} />
                  )}
                  {claim.status.description == "REJECTED-HR" && (
                    <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                  )}
                  {claim.status.description == "REJECTED-S" && (
                    <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                  )}
                </span>
              </OverlayTrigger>
            </td>

            <td className="text-center align-middle" style={{...rowStyle}}>
              {claim.hr_reviewed == false && (
                <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
              )}
              {claim.hr_reviewed == true && (
                <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
              )}
            </td>

            <td className="text-center align-middle" style={{...rowStyle}}>
              <Form.Check
                type="checkbox"
                id={`checkbox-${claim.id}`}
                name={`checkbox-${claim.id}`}
                onChange={(e) => handleCheckChange(e, claim.id)}
                checked={selectedCheckboxes.includes(claim.id)}
              />
            </td>
          </>
        ) : (
          <>
            <td style={{...rowStyle}} onClick={()=>handleClickView(claim.id)}>{moment(claim.created).format("YYYY-MM-DD")}</td>
            {/* <td style={{...rowStyle}} onClick={() => handleClickView(claim.id)}>
                {claim.employee.service_length.id === "P" && (
                    <span className="custom-tooltip" data-toggle={"Date Joined: "+moment(claim?.employee?.date_joined).format("YYYY-MM-DD")}><b>*&nbsp;</b> </span>
                )}
                {claim.employee.status.id === 2 && (
                    <span className="custom-tooltip" data-toggle={"Date Leaving: "+moment(claim?.employee?.date_left).format("YYYY-MM-DD")}><b>**</b> </span>              
                )}
                {
                  claim.employee.fullname
                    ?.toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
                }
            </td> */}
            <td style={{ ...rowStyle }}>
              <div onClick={() => handleClickView(claim.id)} className="flex items-center gap-1">
                {claim.employee.service_length.id === "P" && (
                  <span
                    // className="custom-tooltip"
                    title={`Date Joined: ${moment(claim?.employee?.date_joined).format("YYYY-MM-DD")}`}
                  >
                    <b>*&nbsp;</b>
                  </span>
                )}
                {claim.employee.status.id === 2 && (
                  <span
                    // className="custom-tooltip"
                    title={`Date Leaving: ${moment(claim?.employee?.date_left).format("YYYY-MM-DD")}`}
                  >
                    <b>**</b>
                  </span>
                )}
                <span className="truncate inline-block max-w-full">
                  {
                    claim.employee.fullname
                      ?.toLowerCase()
                      .split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ')
                  }
                </span>
              </div>
            </td>
            <td style={{...rowStyle}} onClick={()=>handleClickView(claim.id)}>{claim.receipt_reference}</td>
            <td style={{...rowStyle}} onClick={()=>handleClickView(claim.id)}>{claim.receipt_no}</td>
            <td style={{...rowStyle}} onClick={()=>handleClickView(claim.id)}>{claim.amount}</td>
            <td className="text-center align-middle" style={{...rowStyle}}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{claim.status.description}</Tooltip>}
              >
                <span>
                  {claim.status.description == "APPROVED-HR" && (
                    <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                  )}
                  {claim.status.description == "APPROVED-S" && (
                    <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
                  )}
                  {claim.status.description == "PENDING" && (
                    <FontAwesomeIcon icon={faHourglass} style={{color: "#FFD43B",}} />
                  )}
                  {claim.status.description == "WITHDRAWN" && (
                    <FontAwesomeIcon icon={faReply} style={{color: "#FFD43B",}} />
                  )}
                  {claim.status.description == "REJECTED-HR" && (
                    <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                  )}
                  {claim.status.description == "REJECTED-S" && (
                    <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
                  )}
                </span>
              </OverlayTrigger>
            </td>

            <td className="text-center align-middle" style={{...rowStyle}}>
              {claim.hr_reviewed == false && (
                <FontAwesomeIcon icon={faClose} style={{color: "#f22c2c",}} />
              )}
              {claim.hr_reviewed == true && (
                <FontAwesomeIcon icon={faCheck} style={{color: "#3fa64b",}} />
              )}
            </td>
            
            <td style={{...rowStyle}}>
              <Form.Check
                type="checkbox"
                id={`checkbox-${claim.id}`}
                name={`checkbox-${claim.id}`}
                onChange={(e) => handleCheckChange(e, claim.id)}
                checked={selectedCheckboxes.includes(claim.id)}
              />
            </td>
          </>
        )}
      </tr>
    )});
  };

  useEffect(() => {
    console.log(selectedCheckboxes);
  }, [selectedCheckboxes]);

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">HR Review Medical Claims</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Row className="justify-content-center my-3">
          <Col md={5} sm="auto">
            <InputGroup className="mb-3">
              <Form.Control 
                placeholder="Enter Employee Name" 
                value={searchText} 
                onChange={handleSearch} 
                onKeyPress={handleKeyPress}
              />
            </InputGroup>
          </Col>
          <Col md="auto" sm="auto">
            <Form.Label className="FormLabel">From Date:</Form.Label>
          </Col>
          <Col md="2" sm="1">
            {/* <Form.Control type="date" name="fromDate" value={fromDate} onChange={handleDateChange}/> */}
            <DatePicker
              selected={fromDate ? new Date(fromDate) : null}
              onChange={(date) =>
                handleDateChange({
                  target: {
                    name: "fromDate",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className="form-control w-100 datepicker-icon"
            />
          </Col>
          <Col md="auto" sm="auto">
            <Form.Label className="FormLabel">To Date:</Form.Label>
          </Col>
          <Col md="2" sm="1">
            {/* <Form.Control type="date" name="toDate" value={toDate} onChange={handleDateChange}/> */}
            <DatePicker
              selected={toDate ? new Date(toDate) : null}
              onChange={(date) =>
                handleDateChange({
                  target: {
                    name: "toDate",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className="form-control w-100 datepicker-icon"
            />
          </Col>
          <Col md="auto" sm="auto">
            <ButtonGroup>
              <Button className="Button" onClick={handleBtnSearch}>
                Search
              </Button>
            </ButtonGroup>
          </Col>
        </Row>

        {/* <ButtonGroup className="my-2 ms-auto">
          <Button className="Button" onClick={handleBtnDownload}>
            Download
          </Button>
        </ButtonGroup> */}
        {/* {selectedCheckboxes.length > 0 ? (
          <ButtonGroup className="my-2 ms-auto">
            <Button className="Button" onClick={handleBtnDownloadAttachment}>
              Download Attachments
            </Button>
          </ButtonGroup>
        ) : (
          <ButtonGroup className="my-2 ms-auto">
            <Button className="Button" onClick={handleBtnDownload}>
              Download Lists
            </Button>
          </ButtonGroup>
        )} */}
        <div className="d-flex justify-content-end mb-3">
          <ButtonGroup className="me-2">
            <Button className="Button" onClick={handleBtnDownload}>
              Download Excel Report
            </Button>
          </ButtonGroup>
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnDownloadAttachment} disabled={selectedCheckboxes.length === 0}>
              Download Attachments
            </Button>
          </ButtonGroup>
        </div>

        {/* <br/> */}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div style={{ overflowX: 'auto' }}>
        <Table className="my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
          <thead>
            <tr>
              {isMobile ? (
                <>
                  <th style={{ width: "60px" }}>Medical Claims</th>
                  <th style={{ width: "5px" }} className="text-center align-middle">Status</th>
                  <th style={{ width: "4px" }} className="text-center align-middle">
                    <FontAwesomeIcon icon={faEye} />
                  </th>
                  <th style={{ width: "4px" }} className="text-center align-middle" onClick={handleSelectAll}>
                    <FontAwesomeIcon icon={faBoltLightning} title="Click to Select All" />
                  </th>
                </>
              ) : (
                <>
                  <th style={{ width: "120px" }}>Date Applied</th>
                  <th style={{ width: "250px" }}>Employee</th>
                  <th style={{ width: "150px" }}>Receipt No.</th>
                  <th style={{ width: "200px" }}>Practitioner</th>
                  <th style={{ width: "70px" }}>Claim</th>
                  <th style={{ width: "50px" }} className="text-center align-middle">Status</th>
                  <th style={{ width: "65px" }} className="text-center align-middle">
                    <FontAwesomeIcon icon={faEye} title="Review" />
                  </th>
                  <th style={{ width: "40px" }} className="text-center align-middle" onClick={handleSelectAll}>
                    <FontAwesomeIcon icon={faBoltLightning} title="Click to Select All" />
                  </th>
                </>
              )}
            </tr>
          </thead>
          {!loading && (
            <tbody>
              {medicalClaims.length > 0 ? (
                renderStaffList()
              ) : (
                <tr>
                  {/* <td colSpan="8">No results found</td> */}
                  <td colSpan={isMobile ? "3" : "8"}>No results found</td>
                </tr>
              )}
            </tbody>
          )}
        </Table>
        </div>

        <div className="legend-pagination-row">
          <div className="legend-container">
            <div className="legend-row">
              <span className="legend-item" style={{ color: "black" , fontSize: "14px" }}>* - Probation, ** - Resigning</span>
            </div>
          </div>

          <div
            style={{
              marginLeft: "auto",
              marginTop: isMobile ? "10px" : "0px"
            }}
          >
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePreviousPage={handlePreviousPage}
              handleNextPage={handleNextPage}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>

        {/* <span style={{color: "white"}}>* - Probation, ** - Resigning</span> */}

        <div className="d-flex justify-content-between">
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
            &nbsp;
          </ButtonGroup>

          {/* Right side */}
          <div className="d-flex">
            <ButtonGroup className="me-2">
              <Button className="Button" onClick={handleBtnDownload}>
                Download Excel Report
              </Button>
            </ButtonGroup>
            <ButtonGroup>
              <Button className="Button" onClick={handleBtnDownloadAttachment} disabled={selectedCheckboxes.length === 0}>
                Download Attachments
              </Button>
            </ButtonGroup>
          </div>
          {/* {selectedCheckboxes.length > 0 ? (
            <ButtonGroup>
              <Button className="Button" onClick={handleBtnDownloadAttachment}>
                Download Attachments
              </Button>
            </ButtonGroup>
          ) : (
            <ButtonGroup>
              <Button className="Button" onClick={handleBtnDownload}>
                Download Lists
              </Button>
            </ButtonGroup>
          )} */}
        </div>
      </Card>
    </div>
  );
};
export default HRReviewMedicalList;